import { studentModule } from '@/store/student/module'

const getStudentOrgs = () => {
    return studentModule.state.organizations
}

const getStudentOrgNames = () => {
    return studentModule.state.organizations.map(org => org.name)
}

export default {
    getStudentOrgs,
    getStudentOrgNames,
}
